enum TT_DON_KINH {
  CHUA_BAN = "CB",
  DA_BAN = "DB",
  // DA_THANH_TOAN = "DTT",
  // HOAN_THANH = "HT",
  HOAN_LAI = "HL",
  HUY = "H",
}
enum LOAI_DON_KINH {
  TAO_MOI = "TAO_MOI",
  DA_TAO = "DA_TAO",
}
export {TT_DON_KINH, LOAI_DON_KINH};
